module.exports = __webpack_public_path__ + "static/index-background-ef9d5c0d3c9ba5bb962ba10a5e6bbfad.jpg";